import { render, staticRenderFns } from "./CreateDescuentoModal.vue?vue&type=template&id=5d52a2be"
import script from "./CreateDescuentoModal.vue?vue&type=script&lang=js"
export * from "./CreateDescuentoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports